<template>
  <div class="course-container">
    <!-- 顶部信息栏 -->
    <div class="course-main">
      <!-- 头部区域 -->
      <div class="virtual-experiment-container">
        <div>
          <h1>液压与气压传动技术</h1>
          <div class="badge">国家级一流课程</div>
          <div class="author-info">
            何芹 | 山东建筑大学 | 上线时间：2017年
          </div>
          <div class="course-meta">
            所属专业类：机械类  对应专业：机械工程  课程类型：专业基础课  实验类型：基础练习型<br>
            所属课程：液压与气压传动技术
          </div>
          <div class="course-description" >
            <div class="left-content">
              <p class="description" >
                山东建筑大学国家级建筑工程及装备虚拟仿真实验教学中心，属全国首批。本中心创新了“VR实验三步法”，即第一步学生利用“AR实验指导书”预习；第二步教师利用VR“黑板”讲解实验；第三步学生借助手机APP完成虚拟仿真并指导真实实验。液压基本回路拼装虚拟仿真实验项目，旨在使学生运用液压传动知识，独立设计、拼装常见液压基本回路，并测试回路性能参数。本实验具有高度仿真、深度交互等效果，解决了台套数不足问题。实验已在山东大学等高校进行共享。
              </p>
            </div>

            <div class="right-content">
              <div class="video-preview">
                <!-- 视频容器，包含预览图和播放按钮 -->
                <video
                  id="labVideo"
                  class="cover-image"
                  poster="https://kmsmai.oss-cn-beijing.aliyuncs.com/file/video/2c9180ad-66f78327-0166-fbc721e9-00ac%20%281%29.jpg"
                  controls="controls"
                  preload="metadata"
                >
                  <!-- 替换为实际视频文件地址，支持多种格式 -->
                  <source src="https://oss.keming365.com/file/video/2c9180ad-66f78327-0166-fbc721e9-00ac.mp4" type="video/mp4">
                  <p>您的浏览器不支持视频播放</p>
                </video>

                <!-- 自定义播放按钮（覆盖在视频上方） -->
                <!--<button class="play-btn" id="playButton">
                  <i class="icon-play"></i>
                </button>-->

                <div class="video-title">实验简介视频</div>
              </div>
            </div>
          </div>

        </div>

      </div>

      <!-- 教师团队模块 -->
      <div class="teacher-team">
        <div class="stats-container">
          <div class="stats-item">
            <h2 class="title">开课9学期</h2>
            <div class="subtitle">
              <span class="semester">2025春夏</span>
              <span class="status">已运行</span>
            </div>
            <p class="update-time">更新时间：{{ currentTime }}</p>
          </div>
          <div class="stats-item">
            <h2 class="title">21,766人</h2>
            <p class="subtitle">累计选课</p>
            <p class="current-term">本学期合计1,439人</p>
          </div>
          <div class="stats-item">
            <h2 class="title">44所</h2>
            <p class="subtitle">选课学校</p>
            <p class="current-term">本学期合计14所</p>
          </div>
          <div class="stats-item">
            <h2 class="title">54,714次</h2>
            <p class="subtitle">累计互动</p>
            <p class="current-term">本学期合计13,534次</p>
          </div>
        </div>
      </div>

      <!-- 选项卡 -->
      <div class="tab-nav" :class="{ 'fixed-tab': isFixed }">
        <div class="tabs-content">
          <button
            v-for="(tab, index) in tabList"
            :key="tab.key"
            class="tab-item"
            :class="{ active: currentTab === tab.key }"
            @click="currentTab = tab.key"
          >
            {{ tab.label }}
            <div v-if="currentTab === tab.key" class="underline"></div>
          </button>
        </div>
      </div>

      <!-- 选项卡内容容器 -->
      <div class="content-container">
        <!-- 课程概述 -->
        <div v-show="currentTab === 'overview'" class="tab-pane">
          <OverviewPage ref="overviewPage"/>
        </div>

        <!-- 课程视频 -->
        <div v-show="currentTab === 'videos'" class="tab-pane">
          <VideosPage ref="videosPage"/>
        </div>

        <!-- vr应用 -->
        <div v-show="currentTab === 'vr'" class="tab-pane">
          <VrPage ref="vrPage"/>
        </div>

        <!-- 教学资源 -->
        <div v-show="currentTab === 'resources'" class="tab-pane">
          <ResourcePage ref="resourcePage"/>
        </div>

        <!-- 能力图谱 -->
        <div v-show="currentTab === 'ability'" class="tab-pane">
          <AbilityPage ref="abilityPage"/>
        </div>

        <!-- AI助手 -->
        <div v-show="currentTab === 'kmai'" class="tab-pane">
          <KmaiPage ref="kmaiPage"/>
        </div>
      </div>
    </div>
    <div class="back-to-top" v-if="showBackTop" @click="scrollToTop">
      ↑
    </div>
  </div>
</template>

<script>
  import OverviewPage from '../../components/tp/OverviewPage.vue'
  import VideosPage from '../../components/tp/VideosPage.vue'
  import ResourcePage from '../../components/tp/ResourcePage.vue'
  import AbilityPage from '../../components/tp/AbilityPage.vue'
  import KmaiPage from '../../components/tp/KmaiPage.vue'
  import VrPage from '../../components/tp/VrPage.vue'
  export default {
    components: {
      OverviewPage,
      VideosPage,
      ResourcePage,
      AbilityPage,
      KmaiPage,
      VrPage
    },
    data() {
      return {
        showBackTop: false,
        currentTime: '',
        currentTab: 'overview',
        tabList: [
          { key: 'overview', label: '课程概述' },
          { key: 'videos', label: '课程视频' },
          { key: 'vr', label: 'VR资源' },
          { key: 'resources', label: '其他资源' },
          { key: 'ability', label: '知识图谱' },
          { key: 'kmai', label: 'AI+教育大模型' }
        ],
        isFixed: false,
        teachers: [
        ],
        courseVideos: [
        ],
        courseResources: [
        ],
        abilityNodes: [
        ]
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll);
      this.updateTime();
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      scrollToTop() {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      },
      formatNumber(num) {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
      handleScroll() {
        // 滚动到一定位置后固定（示例：距离顶部100px）
        this.isFixed = window.scrollY > 800;
        this.showBackTop = window.scrollY > 300;
      },
      updateTime() {
        const date = new Date();
        this.currentTime = this.formatDate(date);
      },

      // 日期格式化方法（补零处理）
      formatDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
    }
  }
</script>

<style scoped>
  /* ======= 全局重置 ======= */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
  }
  html, body {
    width: 100%;
    overflow-x: hidden;
    font-family: "PingFang SC", "Microsoft YaHei", sans-serif;
    line-height: 1.6;
    background-color: #f8f9fa;
    color: #212529;
  }

  /* ======= 背景容器 ======= */
  .course-container {
    margin: 0 auto;
    background: linear-gradient(to bottom, transparent 80%, #fff 100%),
    url(~@/assets/tpbj.png) 0% 0% / cover no-repeat;
  }

  /* ======= 主内容容器 ======= */
  .course-main {
    max-width: 1440px;
    margin: 20px auto;
    padding: 0 24px;
  }

  /* ======= 标题 + 标签 + 作者信息 ======= */
  .course-main h1 {
    font-size: 32px;
    text-align: center;
    font-weight: 700;
    color: #222;
    margin-bottom: 12px;
  }
  .badge {
    display: inline-block;
    background: linear-gradient(90deg, #4f46e5, #6366f1);
    color: #fff;
    font-size: 12px;
    font-weight: bold;
    padding: 4px 10px;
    border-radius: 999px;
    margin: 0 auto 8px;
  }
  .author-info {
    text-align: center;
    color: #666;
    font-size: 18px;
    margin-bottom: 8px;
  }
  .course-meta {
    text-align: center;
    font-size: 16px;
    color: #888;
    margin-bottom: 20px;
  }

  /* ======= 视频 + 简介卡片 ======= */
  .course-description {
    display: flex;
    justify-content: space-between;
    background: #fff;
    padding: 32px;
    border-radius: 16px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
    gap: 32px;
    align-items: flex-start;
    margin-bottom: 40px;
  }
  .left-content {
    flex: 1;
  }
  .description {
    font-size: 17px;
    line-height: 1.8;
    color: #444;
    display: -webkit-box;
    -webkit-line-clamp: 10;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .right-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .cover-image {
    width: 300px;
    max-width: 400px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  }
  .video-title {
    text-align: center;
    margin-top: 12px;
    font-size: 15px;
    color: #555;
  }

  /* ======= 教师团队统计 ======= */
  .teacher-team {
    margin-top: 2rem;
    margin-bottom: 10px;
  }
  .stats-container {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 20px;
    padding: 2rem;
    border: 1px solid #fff;
    background: rgba(255, 255, 255, 0.5);
    backdrop-filter: blur(8px);
    border-radius: 16px;
  }
  .stats-item {
    flex: 1 1 22%;
    min-width: 180px;
    text-align: center;
  }
  .stats-item .title {
    font-weight: bold;
    font-size: 16px;
    color: #604ffd;
    margin-bottom: 8px;
  }
  .stats-item .subtitle {
    color: #6495ed;
    font-size: 14px;
  }
  .stats-item .update-time,
  .stats-item .current-term {
    font-size: 13px;
    color: #696969;
  }

  /* ======= Tab导航 ======= */
  .tab-nav {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 12px 20px;
    background: #fff;
    border-radius: 20px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
    margin: 20px auto;
    max-width: 95%;
  }
  .fixed-tab {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    width: calc(100% - 30px);
    z-index: 999;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  .tabs-content {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
  }
  .tab-item {
    font-size: 16px;
    font-weight: 800;
    cursor: pointer;
    padding: 5px 10px;
    background: transparent;
    color: #333;
    border: none;
    position: relative;
    transition: color 0.3s;
  }
  .tab-item.active {
    color: #4169e1;
  }
  .underline {
    position: absolute;
    bottom: -2px;
    left: 0;
    width: 100%;
    height: 2px;
    background: #4169e1;
    border-radius: 1px;
  }

  /* ======= Tab内容容器 ======= */
  .content-container {
    padding: 20px 0;
    margin-top: 20px;
  }
  .tab-pane {
    animation: fadeIn 0.3s ease;
  }
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(10px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  /* ======= 视频列表区 ======= */
  .video-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
    gap: 20px;
  }
  .video-card {
    background: #fff;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 16px rgba(0,0,0,0.05);
    transition: transform 0.2s;
  }
  .video-card:hover {
    transform: translateY(-4px);
  }
  .video-cover {
    height: 180px;
    background-size: cover;
    background-position: center;
  }
  .video-meta {
    padding: 16px;
  }
  .video-title {
    font-size: 15px;
    font-weight: 600;
    color: #222;
    margin-bottom: 6px;
  }
  .video-stats {
    font-size: 13px;
    color: #666;
  }

  /* ======= 教学资源 ======= */
  .resource-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
  .resource-item {
    background: #f8f9fa;
    border-radius: 12px;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    gap: 20px;
    transition: all 0.3s;
  }
  .resource-item:hover {
    background: #f0f2f5;
    transform: translateX(6px);
  }
  .resource-type {
    width: 40px;
    height: 40px;
    background: #e3e7ff;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .resource-detail {
    flex: 1;
  }
  .resource-name {
    font-size: 15px;
    font-weight: 500;
    color: #212529;
    margin-bottom: 4px;
  }
  .resource-info {
    font-size: 13px;
    color: #666;
  }
  .resource-download {
    color: #646cff;
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;
  }

  /* ======= 能力图谱 ======= */
  .ability-chart {
    height: 500px;
    border: 1px solid #f0f2f5;
    border-radius: 12px;
    background: #f8f9fa;
    position: relative;
  }
  .chart-node {
    position: absolute;
    text-align: center;
    transition: transform 0.2s;
    cursor: pointer;
  }
  .chart-node:hover {
    transform: scale(1.08);
  }
  .node-circle {
    width: 48px;
    height: 48px;
    background: #e0e7ff;
    border-radius: 50%;
    margin: 0 auto 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .node-name {
    font-size: 13px;
    font-weight: 500;
  }
  .node-progress {
    font-size: 12px;
    color: #666;
  }

  /* ======= AI助手区 ======= */
  .ai-features {
    display: flex;
    flex-wrap: wrap;
    gap: 24px;
    justify-content: center;
  }
  .ai-avatar {
    text-align: center;
  }
  .ai-avatar img {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    margin-bottom: 8px;
    box-shadow: 0 4px 8px rgba(0,0,0,0.08);
  }
  .feature {
    text-align: center;
    padding: 12px;
    background: rgba(255,255,255,0.8);
    border-radius: 10px;
  }
  .tag {
    display: inline-block;
    padding: 6px 14px;
    background: #e3e7ff;
    color: #4f46e5;
    font-size: 13px;
    font-weight: 500;
    border-radius: 999px;
    margin: 4px;
  }

  /* ======= 返回顶部按钮 ======= */
  .back-to-top {
    position: fixed;
    bottom: 60px;
    right: 40px;
    width: 50px;
    height: 50px;
    background: #c0e0fe;
    color: white;
    font-size: 24px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    box-shadow: 0 4px 10px rgba(0,0,0,0.3);
  }
  .back-to-top:hover {
    background: #85c2f1;
  }

  /* ======= 响应式优化 ======= */
  @media (max-width: 1024px) {
    .course-description {
      flex-direction: column;
      padding: 20px;
    }
    .left-content, .right-content {
      width: 100%;
      padding: 0 !important;
    }
    .cover-image {
      width: 100%;
      max-width: 100%;
      margin-bottom: 16px;
    }
    .stats-container {
      flex-direction: column;
    }
    .stats-item {
      width: 100%;
      margin-bottom: 16px;
    }
    .video-grid {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 768px) {
    .tab-item {
      font-size: 14px;
    }
    .back-to-top {
      width: 40px;
      height: 40px;
      font-size: 20px;
      bottom: 20px;
      right: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/tp.vue